interface Props { peakHours: number[]; }

// CSS bars replace the recharts panel per mockup #6c — "Bars replace the
// recharts panel so the type stays pixel." Bar height is pct-of-max, same
// shape recharts would have drawn; only the rendering method changed, no
// data transform.
export default function PeakHourChart({ peakHours }: Props) {
  const hasTraffic = peakHours.some(c => c > 0);
  const maxCount = Math.max(...peakHours, 1);

  return (
    <div className="bg-white rounded-[10px] p-[18px]">
      <p className="font-heading text-[9px] text-body-grey mb-4">
        PEAK HOURS · LAST {peakHours.length === 24 ? '30D' : `${peakHours.length} BUCKETS`}
      </p>
      {!hasTraffic ? (
        <div className="h-24 flex items-center justify-center text-body-grey font-grotesk text-[13px] text-center px-4">
          No traffic data yet
        </div>
      ) : (
        <div className="flex items-end gap-1 h-24">
          {peakHours.map((count, hour) => (
            <div key={hour} className="flex-1 flex flex-col items-center justify-end gap-1.5 h-full min-w-0">
              <div
                className="w-full bg-pixel-cyan rounded-t-[6px]"
                style={{ height: `${Math.max(4, Math.round((count / maxCount) * 100))}%` }}
              />
              {hour % 3 === 0 && (
                <span className="font-grotesk text-[9px] text-[#a8a29e] leading-none">
                  {hour.toString().padStart(2, '0')}
                </span>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
